import { render, staticRenderFns } from "./Presence.vue?vue&type=template&id=082c31ba&"
import script from "./Presence.vue?vue&type=script&lang=js&"
export * from "./Presence.vue?vue&type=script&lang=js&"
import style0 from "./Presence.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports